/* HeyMara — product page: variant matching, gallery, qty, add-to-cart → drawer.
   Reuses window.HMCart (cart drawer) from hm-shared.js. */
(function () {
  "use strict";

  function init() {
    var root = document.querySelector("[data-product]");
    if (!root || root.dataset.hmBound) return;
    root.dataset.hmBound = "1";

    var dataEl = document.getElementById("pd-variants");
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var idInput = document.getElementById("pd-variant-id");
    var priceEl = document.getElementById("pd-price");
    var addBtn = document.getElementById("AddToCart");
    var addLabel = addBtn ? addBtn.querySelector("[data-add-label]") : null;
    var form = document.getElementById("pd-form");
    var mainImg = document.getElementById("pd-main");
    var qtyWrap = root.querySelector("[data-qty]");
    var qtyVal = root.querySelector("[data-qty-val]");
    var qty = 1;
    var lastVariantId = null;

    /* Keep the URL's ?variant= in sync and notify the variant-id input on real
       changes, so storefront apps (e.g. Appstle Subscriptions) re-render their
       widget for the newly selected variant. */
    function syncVariant(id) {
      try {
        var u = new URL(window.location.href);
        if (u.searchParams.get("variant") !== String(id)) {
          u.searchParams.set("variant", id);
          window.history.replaceState({}, "", u);
        }
      } catch (e) {}
      if (lastVariantId !== null && lastVariantId !== id) {
        idInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
      lastVariantId = id;
    }

    /* ----- gallery: thumb → main ----- */
    var thumbs = [].slice.call(root.querySelectorAll(".pd-thumb"));
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        if (mainImg) { mainImg.src = t.dataset.full; mainImg.dataset.mediaId = t.dataset.mediaId; }
        thumbs.forEach(function (x) { x.classList.toggle("is-active", x === t); });
      });
    });
    function showMedia(mediaId) {
      if (!mediaId) return;
      var t = thumbs.filter(function (x) { return x.dataset.mediaId == mediaId; })[0];
      if (t) t.click();
    }

    /* ----- variant matching ----- */
    function selectedOptions() {
      return [].slice.call(root.querySelectorAll(".pd-opt")).map(function (optEl) {
        var checked = optEl.querySelector("input:checked");
        return checked ? checked.value : null;
      });
    }
    function currentVariant() {
      var opts = selectedOptions();
      if (!opts.length) return variants[0]; // single default variant
      return variants.filter(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      })[0];
    }
    function render() {
      var v = currentVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = "Unavailable";
        return;
      }
      idInput.value = v.id;
      syncVariant(v.id);
      if (priceEl) {
        priceEl.innerHTML = '<span class="pd-price-now">' + v.price + "</span>" +
          (v.compare_at ? ' <s class="pd-price-was">' + v.compare_at + "</s>" : "");
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? "Add to cart" : "Sold out";
      if (v.media_id) showMedia(v.media_id);
    }

    root.querySelectorAll(".pd-opt input[type=radio]").forEach(function (r) {
      r.addEventListener("change", render);
    });

    /* ----- quantity ----- */
    if (qtyWrap) {
      qtyWrap.querySelectorAll("button[data-step]").forEach(function (b) {
        b.addEventListener("click", function () {
          qty = Math.max(1, qty + (parseInt(b.dataset.step, 10) || 0));
          if (qtyVal) qtyVal.textContent = qty;
        });
      });
    }

    /* ----- add to cart → open drawer ----- */
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var v = currentVariant();
        if (!v || !v.available || !addBtn || addBtn.disabled) return;
        var prev = addLabel ? addLabel.textContent : "";
        if (addLabel) addLabel.textContent = "Adding…";
        addBtn.disabled = true;
        var item = { id: Number(v.id), quantity: qty };
        // Appstle Subscriptions renders radios name="selling_plan" (one-time = ""); pass the chosen plan.
        var sp = (form.querySelector('input[name="selling_plan"]:checked') ||
                  document.querySelector('input[name="selling_plan"]:checked'));
        if (sp && sp.value) item.selling_plan = Number(sp.value);
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (window.HMCart) window.HMCart.refresh({ open: true });
            if (addLabel) addLabel.textContent = "Added ✓";
            setTimeout(function () { if (addLabel) addLabel.textContent = prev || "Add to cart"; addBtn.disabled = false; }, 1200);
          })
          .catch(function () {
            if (addLabel) addLabel.textContent = prev || "Add to cart";
            addBtn.disabled = false;
          });
      });
    }

    render();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
